import InstagramViewerSmallViewPort from "./InstagramViewerSmallViewPort";

export default InstagramViewerSmallViewPort;
